import { render, staticRenderFns } from "./ElementTargetAchieveLevelGrowthTableColumn.vue?vue&type=template&id=21d0e79a&scoped=true"
import script from "./ElementTargetAchieveLevelGrowthTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementTargetAchieveLevelGrowthTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementTargetAchieveLevelGrowthTableColumn.vue?vue&type=style&index=0&id=21d0e79a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0e79a",
  null
  
)

export default component.exports